"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisWebRtc = void 0;
const package_json_1 = __importDefault(require("../package.json"));
const IrisRtcEngine_1 = require("./engine/IrisRtcEngine");
const util_1 = require("./util");
function initIrisRtc(irisApiEngine, options) {
    var _a;
    irisApiEngine.addApiInterceptor((_a = options === null || options === void 0 ? void 0 : options.irisRtcEngine) !== null && _a !== void 0 ? _a : new IrisRtcEngine_1.IrisRtcEngine(irisApiEngine.getIrisEventHandlerManager(), options));
    // set the first irisApiEngine apiInterceptors to irisClientManager
    // this is a convenient way to get irisClientManager in most cases
    setTimeout(() => {
        var _a;
        if (window.__AGORA_IRIS_API_ENGINE_LIST__.length === 1) {
            window.__AGORA_IRIS_CLIENT_MANAGER__ =
                (_a = window.__AGORA_IRIS_API_ENGINE_LIST__[0]['apiInterceptors'][0]) === null || _a === void 0 ? void 0 : _a.irisClientManager;
        }
    }, 1000);
}
exports.IrisWebRtc = {
    IrisRtcEngine: IrisRtcEngine_1.IrisRtcEngine,
    AgoraConsole: util_1.AgoraConsole,
    initIrisRtc: initIrisRtc,
};
window.__AGORA_IRIS_VERSION__ = package_json_1.default.version;
